import { render, staticRenderFns } from "./NotAllowedPage.vue?vue&type=template&id=2a6c33b9&scoped=true&"
import script from "./NotAllowedPage.vue?vue&type=script&lang=js&"
export * from "./NotAllowedPage.vue?vue&type=script&lang=js&"
import style0 from "./NotAllowedPage.vue?vue&type=style&index=0&id=2a6c33b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c33b9",
  null
  
)

export default component.exports